<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Picking Supply For Subcontract" active>

                                <b-row v-if="hasFailedDataPickingSupplyForSubcontract">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingSupplyForSubcontract.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForSubcontractsFailed" :fields="fieldsPickingSupplyForSubcontract" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForSubcontract" :sort-desc.sync="sortDescPickingSupplyForSubcontract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(materialIssueDate)="row">
													{{ row.item.materialIssueDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingSupplyForSubcontract.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForSubcontracts" :fields="fieldsPickingSupplyForSubcontract" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForSubcontract" :sort-desc.sync="sortDescPickingSupplyForSubcontract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(materialIssueDate)="row">
													{{ row.item.materialIssueDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Picking Supply For Subcontract Detail" active>

                                <b-row v-if="hasFailedDataPickingSupplyForSubcontractDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingSupplyForSubcontractDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForSubcontractDetailsFailed" :fields="fieldsPickingSupplyForSubcontractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForSubcontractDetail" :sort-desc.sync="sortDescPickingSupplyForSubcontractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(supplyQty)="row">
													{{ Number(row.item.supplyQty).toLocaleString() }}
												</template>
												<template #cell(actualQty)="row">
													{{ Number(row.item.actualQty).toLocaleString() }}
												</template>
												<template #cell(processDate)="row">
													{{ row.item.processDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingSupplyForSubcontractDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForSubcontractDetails" :fields="fieldsPickingSupplyForSubcontractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForSubcontractDetail" :sort-desc.sync="sortDescPickingSupplyForSubcontractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(supplyQty)="row">
													{{ Number(row.item.supplyQty).toLocaleString() }}
												</template>
												<template #cell(actualQty)="row">
													{{ Number(row.item.actualQty).toLocaleString() }}
												</template>
												<template #cell(processDate)="row">
													{{ row.item.processDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PickingSupplyForSubcontract from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontract';
import PickingSupplyForSubcontractList from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractList';
import PickingSupplyForSubcontractFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPickingSupplyForSubcontract: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply (W/O No)", key: 'workOrderSupplySubcontractMaterialIssueNumber', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},
				{"class" : "th-status", "label" : "Material Issue Date", key: 'materialIssueDate', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPickingSupplyForSubcontractDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply For Subcon Detail", key: 'workOrderSupplyForSubconDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Supply Qty", key: 'supplyQty', sortable: false},
				{"class" : "th-status", "label" : "Actual Qty", key: 'actualQty', sortable: false},
				{"class" : "th-status", "label" : "Is Complete", key: 'isCompleted', sortable: false},
				{"class" : "th-status", "label" : "Process By", key: 'processByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Process Date", key: 'processDate', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			pickingSupplyForSubcontracts : [],
			pickingSupplyForSubcontractsFailed: [],
			pickingSupplyForSubcontractId : '',
			sortByPickingSupplyForSubcontract: '',
			sortDescPickingSupplyForSubcontract: '',
			hasFailedDataPickingSupplyForSubcontract: false,
			totalFailedPickingSupplyForSubcontract: 0,
			totalSucceedPickingSupplyForSubcontract: 0,
			pickingSupplyForSubcontractDetails : [],
			pickingSupplyForSubcontractDetailsFailed: [],
			pickingSupplyForSubcontractDetailId : '',
			sortByPickingSupplyForSubcontractDetail: '',
			sortDescPickingSupplyForSubcontractDetail: '',
			hasFailedDataPickingSupplyForSubcontractDetail: false,
			totalFailedPickingSupplyForSubcontractDetail: 0,
			totalSucceedPickingSupplyForSubcontractDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('pickingsupplyforsubcontract/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('pickingsupplyforsubcontract/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPickingSupplyForSubcontractForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPickingSupplyForSubcontractForUpload : async function() {
			let _this = this;
			this.$http.get('pickingsupplyforsubcontract/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.pickingSupplyForSubcontracts = [];
_this.pickingSupplyForSubcontractDetails = [];


					if (response != null) {
						let result = response.data;
						_this.pickingSupplyForSubcontracts = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPickingSupplyForSubcontract = _this.pickingSupplyForSubcontracts.length;

						_this.pickingSupplyForSubcontractsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPickingSupplyForSubcontract = true;
						_this.totalFailedPickingSupplyForSubcontract = 0;
						if(_this.pickingSupplyForSubcontractsFailed == undefined || _this.pickingSupplyForSubcontractsFailed.length === 0) _this.hasFailedDataPickingSupplyForSubcontract = false;
						if(_this.hasFailedDataPickingSupplyForSubcontract) _this.totalFailedPickingSupplyForSubcontract = _this.pickingSupplyForSubcontractsFailed.length;
						_this.pickingSupplyForSubcontractDetails = [];
						_this.pickingSupplyForSubcontractDetailsFailed = [];
						_this.hasFailedDataPickingSupplyForSubcontractDetail = true;
						_this.totalSucceedPickingSupplyForSubcontractDetail = 0;
						result.forEach(function(element) {
							_this.pickingSupplyForSubcontractDetails.push(...element.pickingSupplyForSubcontractDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPickingSupplyForSubcontractDetail = _this.pickingSupplyForSubcontractDetails.length;

							_this.pickingSupplyForSubcontractDetailsFailed.push(...element.pickingSupplyForSubcontractDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.pickingSupplyForSubcontractDetailsFailed == undefined || _this.pickingSupplyForSubcontractDetailsFailed.length === 0) _this.hasFailedDataPickingSupplyForSubcontractDetail = false;
							if(_this.hasFailedDataPickingSupplyForSubcontractDetail) _this.totalFailedPickingSupplyForSubcontractDetail = _this.pickingSupplyForSubcontractDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'pickingsupplyforsubcontract/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PickingSupplyForSubcontract.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPickingSupplyForSubcontract = new PickingSupplyForSubcontractFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
